import { Suspense } from "react";

import { Loader } from "@braintrust/braintrust-ui-components";
import type { OfferDetailsUpdateHistoryTableProps } from "@js/apps/jobs/apps/offers/components/details/update-history-table/update-history-table";
import { lazyWithRetry } from "@js/utils/lazy-with-retry";

const OfferDetailsUpdateHistoryTableLazy = lazyWithRetry(async () => {
  const module = await import(
    /* webpackChunkName: "update-history-table" */ "@js/apps/jobs/apps/offers/components/details/update-history-table/update-history-table"
  );

  return { default: module.OfferDetailsUpdateHistoryTable };
});

export type { OfferDetailsUpdateHistoryTableProps };

export const OfferDetailsUpdateHistoryTable = (
  props: OfferDetailsUpdateHistoryTableProps,
) => {
  return (
    <Suspense fallback={<Loader centered />}>
      <OfferDetailsUpdateHistoryTableLazy {...props} />
    </Suspense>
  );
};
